import React, { useContext, useEffect, useState, useRef } from 'react';
import Menu from '../../components/sturtural/Menu';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import Loader from '../../components/sturtural/Loader';
import MessageDetail from '../../components/sturtural/MessageDetail';
import { Toolbar } from 'primereact/toolbar';
import { DataView } from 'primereact/dataview';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import ScannerFiltro from '../../components/sturtural/ScannerFiltro';
import { Checkbox } from 'primereact/checkbox';
import PendientesContext from '../../context/PendientesContext';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from 'primereact/toast';
import { storage } from '../../helpers/storage';


const Pendientes = () => {
    const navigate = useNavigate();

    const [db, setDb] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [cancelacion, setCancelacion] = useState(false);
    const [cancelacionids, setCancelacionIds] = useState(false);
    const [displayDialog_cancelacion, setDisplayDialog_cancelacion] = useState(false);
    const [loading_cancelacion, setLoading_cancelacion] = useState(false);
    const [filtro, setFiltro] = useState('');
    const [alumnosPendientes, setAlumnosPendientes] = useState(null);
    const [seleccionarTodos, setSeleccionarTodos] = useState(false);
    const [totalPendientes, setTotalPendientes] = useState(null);

    const [motivo, setMotivo] = useState(null);
    const [loading_motivo, setLoadingMotivo] = useState(null);
    const [confirmScanner, setConfirmScanner] = useState(false);

    const [rows, setRows] = useState(20);
    const [first, setFirst] = useState(0);
    const [last, setLast] = useState(20)

    const [firma, setFirma] = useState(false);

    const perfil = storage.get('perfilid');
    const idUsuario = storage.get("id");
    const idTienda = storage.get("IdTienda");
    const ciclo = storage.get('ciclo');
    const usuario = storage.get('usuario');
    const toast = useRef(null);

    useEffect(() => {
        if (db === null) {
            // if (alumnosPendientes !== null) {
            //     alumnosPendientes.sort((a, b) => {
            //         var textA = a.NombreCompleto
            //         var textB = b.NombreCompleto
            //         return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            //     })
            //     setDb(alumnosPendientes)
            // }
            setDb(alumnosPendientes)
        }
    }, [alumnosPendientes])

    useEffect(() => {
        if (db !== null) {
            let listaActual = db.slice(first, last).map(alumno => alumno.IdEncEntrega)
            if (listaActual === checkboxValue) {
                setSeleccionarTodos(true)
            } else {
                setSeleccionarTodos(false)
            }
        }
    }, [first, rows])

    useEffect(() => {
        if (![1, 2, 5, 13, 16, 17].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    useEffect(() => {
        if (db !== null) {
            let selectedValue = [...checkboxValue]
            const all = db.map(x => x.IdEncEntrega)
            if ((all.filter(x => !selectedValue.includes(x))).length === 0) {
                setSeleccionarTodos(true)
            } else {
                setSeleccionarTodos(false)
            }
            // const restante = (all === selectedValue)
            // setSeleccionarTodos(restante)
        }
    }, [db])

    let url = `${BASE_API}BusquedaAlumnos/getAlumnosPendientes`;

    // comentado temporalmente
    useEffect(() => {
        obtenerTotalPendientes()
    }, []);

    useEffect(() => {
        setLoadingMotivo(true);
        helpHttp().post(`${BASE_API}Entrega/CargaMotivoCancelacion`, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then(res => {
            console.log(res)
            if (!res.err) {
                setMotivo(res);
                setError(null);
            } else {
                setMotivo(null);
                setError(res);
            }
            setLoadingMotivo(false);
        });
    }, [url]);

    const obtenerTotalPendientes = () => {
        const ep = `${BASE_API}BusquedaAlumnos/ConsultarTotalTienda`
        helpHttp().post(ep, {
            body: {
                IdCicloEscolar: ciclo.IdCicloEscolar,
                IdTienda: storage.get('IdTienda'),
                parametrosExtra: ''
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => setTotalPendientes(res.data.TotalPendientes))
    }

    const cagaPendientesQr = (carga) => {
        setDb(null);

        var CUPU = "";
        var nombreCompleto = ""
        if ((/^[a-zA-Z\s]*$/).test(carga)) {
            nombreCompleto = carga
        } else if ((/\d+/).test(carga)) {
            CUPU = carga;
        }

        const arrAlumno = {
            "IdAlumno": 0,
            "Folio": CUPU,
            "Nombre": nombreCompleto,
            "ApellidoPaterno": "",
            "ApellidoMaterno": "",
            "Nivel": "",
            "Curp": "",
            "Turno": "",
            "Grado": "",
            "Grupo": "",
            "Escuela": "",
            "CCT": "",
            "Estatus": "",
            "Municipio": "",
            "Localidad": "",
            "IdEstatus": 1,
            "IdEncEntrega": 0,
            "IdDetEntrega": 0,
            "Genero": "",
            "IdTutor": 0,
            "IdTienda": storage.get('IdTienda'),
            "IdTipoVale": 0,
            "Pagina": 1,
            "OrderBy": "",
            "NombreCompleto": "",
            "IdCicloEscolar": ciclo.IdCicloEscolar
        }

        setLoading(true);
        helpHttp().post(url, {
            body: arrAlumno,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then(res => {
            if (!res.err) {

                let result = res.Result;
                const idsremover = JSON.parse(localStorage.getItem('transactionIdAlumno')) || [];
                idsremover.forEach(element => {
                    result.filter((value, index, arr) => {
                        if (element.includes(value.IdAlumno.toString())) {
                            arr.splice(index, 1);
                            return true;
                        }
                        return false;
                    });
                });
                helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
                    body: {
                        sp: "SpdAgregarMovimientoUsuario",
                        tipo: 2,
                        parametros: [
                            { IdUsuario: idUsuario },
                            { IdTienda: idTienda },
                            { IdEtapa: 1 },
                            { IdEncEntrega: JSON.stringify(result.map(x => x.IdEncEntrega)) },
                            { IdAlumno: JSON.stringify(result.map(x => x.IdAlumno)) },
                            { IdCicloEscolar: ciclo.IdCicloEscolar },
                            { ParametrosExtra: "" },
                        ]
                    },
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                }).then(response => {
                    if (response.SUCCESS) {
                        if (response.ITEMS.ErrorNumber === 0) {
                            obtenerTotalPendientes()
                            handlePendientes(result);
                            setError(null);
                            navigate('/multientrega-scanner/${IdAlumno}/${IdEncEntrega}/${Folio}');
                        } else {
                            buscarAlumnoTienda(CUPU, nombreCompleto);
                        }
                    } else {
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Fallo en conexión, intente de nuevo.", life: 3000 });
                    }
                }).catch(error => {
                    console.warn(error);
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Fallo en conexión, intente de nuevo.", life: 3000 });
                })
            } else {
                setAlumnosPendientes(null);
                obtenerPendientes()
                setError(res);
            }
            setConfirmScanner(false)
            setLoading(false);
        });
    }

    const obtenerPendientes = (e) => {
        e !== null || e !== undefined && e.preventDefault()
        setDb(null);

        var CUPU = "";
        var nombreCompleto = ""
        if (e !== null) {
            if ((/^[a-zA-Z\s]*$/).test(filtro)) {
                nombreCompleto = filtro
            } else if ((/\d+/).test(filtro)) {
                CUPU = filtro;
            }
        }

        const arrAlumno = {
            "IdAlumno": 0,
            "Folio": CUPU,
            "Nombre": nombreCompleto,
            "ApellidoPaterno": "",
            "ApellidoMaterno": "",
            "Nivel": "",
            "Curp": "",
            "Turno": "",
            "Grado": "",
            "Grupo": "",
            "Escuela": "",
            "CCT": "",
            "Estatus": "",
            "Municipio": "",
            "Localidad": "",
            "IdEstatus": 1,
            "IdEncEntrega": 0,
            "IdDetEntrega": 0,
            "Genero": "",
            "IdTutor": 0,
            "IdTienda": storage.get('IdTienda'),
            "IdTipoVale": 0,
            "Pagina": 1,
            "OrderBy": "",
            "NombreCompleto": "",
            "IdCicloEscolar": ciclo.IdCicloEscolar
        }

        setLoading(true);
        helpHttp().post(url, {
            body: arrAlumno,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then(res => {
            if (!res.err) {
                if (res.Result.length > 0) {
                    let result = res.Result;
                    //const idsremover = JSON.parse(localStorage.getItem('transactionFolio')) || [];
                    //const idsremover = ["301501","301502"];
                    /*console.log(idsremover);
                    result.filter((value, index, arr) => {
                    if(idsremover.includes(value.Folio)){
                        arr.splice(index, 1);
                            return true;
                        }
                        return false;
                    });*/
                    //result.filter((x) => x.Folio === idsremover.map(Math.sqrt));
                    let totalResult = res.objPaginacionModel.TotalElementos
                    const idsremover = JSON.parse(localStorage.getItem('transactionIdAlumno')) || [];
                    idsremover.forEach(element => {
                        result.filter((value, index, arr) => {
                            if (element.includes(value.IdAlumno.toString())) {
                                arr.splice(index, 1);
                                return true;
                            }
                            return false;
                        });
                    });
                    const arrResult = formatAlumnos(result)
                    obtenerTotalPendientes()
                    setAlumnosPendientes(arrResult);
                    setError(null);
                } else {
                    buscarAlumnoTienda(CUPU, nombreCompleto);
                }
            } else {
                setAlumnosPendientes(null);
                setError(res);
            }
            setLoading(false);
        });
    }

    const buscarAlumnoTienda = async (CUPU, nombreCompleto) => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "spdConsultaFolioTienda",
                tipo: 2,
                parametros: [
                    { Folio: CUPU },
                    { NombreAlumno: nombreCompleto },
                    { IdCicloEscolar: ciclo.IdCicloEscolar }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => toast.current.show({ severity: 'warn', summary: 'Aviso', detail: res.ITEMS.Mensaje, life: 3000 }))
    }

    const handlerRedirect = (alumno) => {
        window.localStorage.setItem('IdAlumno', alumno.IdAlumno);
        window.localStorage.setItem('IdEncEntrega', alumno.IdEncEntrega);
        window.localStorage.setItem('Folio', alumno.Folio);
        window.localStorage.setItem('IdTutor', alumno.IdTutor);
        navigate(`/multientrega-scanner/${alumno.IdAlumno}/${alumno.IdEncEntrega}/${alumno.Folio}`);
    }

    const handlerDisplayDialog_motivoCancelacion = (IdAlumno, IdEncEntrega) => {
        const IdAlumnos = IdAlumno.map(alumno => alumno.IdAlumno)
        setCancelacion(true);
        setCancelacionIds({ IdAlumnos, IdEncEntrega });
    }

    const handleDisplayDialogConfirm_cancelarEntrega = (IdMotivoCancelacion) => {

        if (IdMotivoCancelacion !== cancelacionids.IdMotivoCancelacion) {
            setCancelacionIds({ ...cancelacionids, IdMotivoCancelacion });
        }

        setDisplayDialog_cancelacion(true);
    }

    const formatAlumnos = (result) => {
        let reducedArray = result.reduce((acc, obj) => {
            let accObj = acc.find(accObj => accObj.IdEncEntrega === obj.IdEncEntrega);
            if (accObj != undefined) {
                accObj.alumnos.push(obj);
            } else {
                accObj = { IdEncEntrega: obj.IdEncEntrega, alumnos: [obj] };
                acc.push(accObj);
            }
            return acc;
        }, []);
        return reducedArray;
    }

    const dbItemTemplate = (el, index) => {
        const tutor = [... new Set(el.alumnos.map(x => x.ObjTutor.NombreCompletoTutor))]
        return (
            <div className="col-12 lg:col-12 p-3 shadow-3 surface-card mb-2" key={index}>

                <div className='grid'>
                    <div className='col-1' style={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                        <div id='retirarAlumno' onClick={() => handlerDisplayDialog_motivoCancelacion(el.alumnos, el.IdEncEntrega)} className={((usuario.substring(0, 2)) == '26' ? "hidden " : "inline-flex ") + " align-items-center justify-content-center mr-3 custom-target-icon"} data-pr-tooltip='Cancelar' data-pr-position='right' style={{ width: ' 40px', height: '40px', borderRadius: '10px', background: '#9B2F3E', cursor: 'pointer' }}>
                            <i className="pi pi-trash text-xl" style={{ color: '#FFFFFF' }}></i>
                        </div>
                    </div>
                    <div className='col-10'>
                        {el.alumnos.map((al, index) =>
                            <div key={index} className='col-12'>
                                <span className="text-900 text-xl font-medium mb-2">{al.Folio} - {al.Nombre} {al.ApellidoPaterno} {al.ApellidoMaterno}</span>
                                <p className="text-900 mb-2">{al.Nivel} {`${al.Grado} ${al.Grupo}`}</p>
                                <p className="mt-1 mb-0 text-600 font-medium text-sm">Curp: {al.Curp}</p>
                                <p className="mt-1 mb-0 text-600 font-medium text-sm">Escuela: {al.CCT} "{al.Escuela}" (Ciclo escolar {al.CicloEscolar})</p>
                                <p className="mt-1 mb-0 text-600 font-medium text-sm">Municipio: {al.Municipio}</p>

                            </div>)}
                        <div className="pl-2  mt-3 border-round  flex align-items-center">
                            <div>
                                <p className="mt-1 mb-0  font-medium ">Tutor: {tutor[0]}</p>
                                <p className="mt-1 mb-0" style={{ color: '#9b2f3e' }}>Atendió: {el.alumnos[0].TallaCalceta}</p>
                            </div>

                        </div>
                    </div>

                    <div className='col-1' style={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                        <div className="ml-auto">
                            <Checkbox inputId={'checkOption' + el.IdEncEntrega} name="option" value={el.IdEncEntrega} checked={checkboxValue.indexOf(el.IdEncEntrega) !== -1} onChange={onCheckboxChange} />
                            {/*<div onClick={() => handlerRedirect(el)} className="bg-green-100 inline-flex align-items-center justify-content-center mr-3" style={{'width':' 45px', 'height': '45px', 'borderRadius': '10px'}}>
                                            <i className="pi pi-stop text-green-700 text-3xl"></i>
                                            </div>*/}
                        </div>
                    </div>

                </div>



            </div>
        )
    }

    // const leftToolbarTemplate = () => {
    //     const transactionIdAlumno = JSON.parse(localStorage.getItem('transactionIdAlumno')) || [];
    //     if(transactionIdAlumno.length > 0) {
    //         return (
    //             <div className="my-2">
    //                 <Button label="Terminar proceso" icon="pi pi-lock" className="p-button-secondary mr-2" onClick={() => handleRedirecTerminar()} />
    //                 {/*<Button label="LLEGADA" icon="pi pi-filter" className="p-button-success mr-2" onClick={() => handleDisplay_firma()} />
    //                    <Button label="NOMBRE" icon="pi pi-filter-fill" className="p-button-secondary mr-2" />*/}
    //             </div>
    //         )
    //     }
    // }

    // const toolbarRightTemplate = () => {
    //     return (
    //         <div className="my-2">
    //             <Button label="Terminar proceso" icon="pi pi-lock" className="p-button-secondary mr-2" onClick={() => handleRedirecTerminarMultiple()} />
    //         </div>
    //     )
    // }

    // const leftToolbarTemplate = () => {
    //     return (
    //         <React.Fragment>
    //             <div className='flex'>
    //                 <div id='filtroAlumno'>
    //                     <span className='p-input-icon-left'  >
    //                         <i className='pi pi-search' />
    //                         <InputText placeholder='Buscador por nombre' className='w-15rem lg:w-30rem md:w-10rem' value={filtro} onChange={(e) => setFiltro(e.target.value.toUpperCase())} />
    //                     </span>
    //                 </div>
    //                 <Button label='Buscar' className='p-button ml-3' onClick={() => Search()} />
    //                 <Button label='Limpiar' className='p-button-outlined ml-3' onClick={() => { setDb(alumnosPendientes); setFiltro('') }} />
    //             </div>

    //         </React.Fragment>
    //     )
    // }

    const handleRedirecTerminar = () => {
        let IdAlumno = localStorage.getItem('IdAlumno');
        let IdEncEntrega = localStorage.getItem('IdEncEntrega');
        let Folio = localStorage.getItem('Folio');

        navigate(`/multientrega-tallas/${IdAlumno}/${IdEncEntrega}/${Folio}`);
    }

    const { handlePendientes } = useContext(PendientesContext);
    const handleRedirecTerminarMultiple = () => {
        if (checkboxValue.length > 0) {
            const arrEncEntrega = alumnosPendientes.filter(a => checkboxValue.includes(a.IdEncEntrega)).map(j => j.IdEncEntrega);
            const arrAlumnos = alumnosPendientes.filter(a => checkboxValue.includes(a.IdEncEntrega)).map(j => j.alumnos.map(i => i.IdAlumno)).flat(1);

            helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
                body: {
                    sp: "SpdAgregarMovimientoUsuario",
                    tipo: 2,
                    parametros: [
                        { IdUsuario: idUsuario },
                        { IdTienda: idTienda },
                        { IdEtapa: 1 },
                        { IdEncEntrega: JSON.stringify(arrEncEntrega) },
                        { IdAlumno: JSON.stringify(arrAlumnos) },
                        { IdCicloEscolar: ciclo.IdCicloEscolar },
                        { ParametrosExtra: "" },
                    ]
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(response => {
                if (response.SUCCESS) {
                    if (response.ITEMS.ErrorNumber === 0) {
                        let result = alumnosPendientes.filter(a => checkboxValue.includes(a.IdEncEntrega)).map(x => x.alumnos.map(j => j)).flat(1);

                        /*db.forEach(element => {
                            checkboxValue.forEach(id => {
                                if (element.IdAlumno === id) {
                                    result.push(element)
                                }
                            })
                        })*/
                        handlePendientes(result);
                        return navigate('/multientrega-scanner/${IdAlumno}/${IdEncEntrega}/${Folio}');
                    } else {
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Fallo en conexión, intente de nuevo.", life: 3000 });
                    }
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Fallo en conexión, intente de nuevo.", life: 3000 });
                }
            }).catch(error => {
                console.warn(error);
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Fallo en conexión, intente de nuevo.", life: 3000 });
            })
        }
    }

    const handleDisplay_firma = () => {
        document.body.style.overflow = 'hidden';
        setFirma(true);
    }

    const dialogFooter_cancelacion = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-outlined ml-3" onClick={() => handleConfirm_no()} />
            <Button label="Sí" disabled={loading_cancelacion} icon={!loading_cancelacion ? "pi pi-check" : 'pi pi-spin pi-spinner'} className="p-button ml-3" onClick={() => handlerSubmit_cancelacion()} />
        </>
    );

    const hideDisplayDialogConfirm_cancelacion = () => {
        setDisplayDialog_cancelacion(false);
    }

    const handleConfirm_no = () => {
        hideDisplayDialogConfirm_cancelacion();
    }

    const handlerSubmit_cancelacion = () => {
        setLoading_cancelacion(true);
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "SpdAgregarMovimientoUsuario",
                tipo: 2,
                parametros: [
                    { IdUsuario: idUsuario },
                    { IdTienda: idTienda },
                    { IdEtapa: 3 },
                    { IdEncEntrega: JSON.stringify([cancelacionids.IdEncEntrega]) },
                    { IdAlumno: JSON.stringify(cancelacionids.IdAlumnos) },
                    { IdCicloEscolar: ciclo.IdCicloEscolar },
                    { ParametrosExtra: "" },
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(response => {
            if (response.SUCCESS) {
                if (response.ITEMS.ErrorNumber === 0) {
                    cancelacionids.IdAlumnos.forEach(IdAlumno => {
                        const arrBody = {
                            "IdEncEntrega": cancelacionids.IdEncEntrega,
                            "IdTienda": storage.get('IdTienda'),
                            "IdUsuario": storage.get('id'),
                            "IdTutor": 0,
                            "FechaCreacion": "",
                            "Latitud": "",
                            "Longitud": "",
                            "IdEstatus": 3,
                            "IdMotivoCancelacion": cancelacionids.IdMotivoCancelacion,
                            "FechaModificacion": "",
                            "IdUsuarioModificacion": 0,
                            "MotivoCancelacion": "0",
                            "alumnosId": [IdAlumno],
                            "OtroMotivoCancelacion": "",
                            "IdAlumno": IdAlumno,
                            "IdTipoVale": 0,
                            "JustificacionDeCancelacion": "0",
                            "IdDocumento": 0
                        }

                        helpHttp().post(`${BASE_API}Entrega/CancelarEntregaPendiente`, {
                            body: arrBody,
                            headers: {
                                "Content-Type": "application/json; charset=utf-8",
                                "Accept": "application/json",
                                'Authorization': `Bearer ${storage.get('token')}`
                            },
                        }).then(res => {
                            if (!res.err) {
                                const arrAlumno = {
                                    "IdAlumno": 0,
                                    "Nombre": "",
                                    "ApellidoPaterno": "",
                                    "ApellidoMaterno": "",
                                    "Nivel": "",
                                    "Curp": "",
                                    "Turno": "",
                                    "Grado": "",
                                    "Grupo": "",
                                    "Escuela": "",
                                    "CCT": "",
                                    "Estatus": "",
                                    "Municipio": "",
                                    "Localidad": "",
                                    "IdEstatus": 1,
                                    "IdEncEntrega": 0,
                                    "IdDetEntrega": 0,
                                    "Genero": "",
                                    "IdTutor": 0,
                                    "IdTienda": storage.get('IdTienda'),
                                    "IdTipoVale": 0,
                                    "Pagina": 1,
                                    "OrderBy": "",
                                    "NombreCompleto": "",
                                    "IdCicloEscolar": ciclo.IdCicloEscolar
                                }

                                setLoading(true);
                                helpHttp().post(url, {
                                    body: arrAlumno,
                                    headers: {
                                        "Content-Type": "application/json; charset=utf-8",
                                        "Accept": "application/json",
                                        'Authorization': `Bearer ${storage.get('token')}`
                                    },
                                }).then(res => {
                                    if (!res.err) {
                                        let result = res.Result;
                                        //const idsremover = JSON.parse(localStorage.getItem('transactionFolio')) || [];
                                        //const idsremover = ["301501","301502"];
                                        /*console.log(idsremover);
                                        result.filter((value, index, arr) => {
                                        if(idsremover.includes(value.Folio)){
                                            arr.splice(index, 1);
                                                return true;
                                            }
                                            return false;
                                        });*/
                                        //result.filter((x) => x.Folio === idsremover.map(Math.sqrt));
                                        const idsremover = JSON.parse(localStorage.getItem('transactionIdAlumno')) || [];
                                        idsremover.forEach(element => {
                                            result.filter((value, index, arr) => {
                                                if (element.includes(value.IdAlumno.toString())) {
                                                    arr.splice(index, 1);
                                                    return true;
                                                }
                                                return false;
                                            });
                                        });
                                        const arrResult = formatAlumnos(result)
                                        setAlumnosPendientes(arrResult);
                                        obtenerPendientes()
                                        setDb(arrResult);
                                        setError(null);
                                    } else {
                                        setAlumnosPendientes(null);
                                        obtenerPendientes()
                                        setError(res);
                                    }
                                    obtenerTotalPendientes();
                                    setLoading(false);
                                    setLoading_cancelacion(false);
                                    setFiltro('')
                                });
                            } else {
                                //setDb(null);
                                //setError(res);
                            }
                        });
                    })
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Fallo en conexión, intente de nuevo.", life: 3000 });
                }
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Fallo en conexión, intente de nuevo.", life: 3000 });
            }
        }).catch(error => {
            console.warn(error);
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Fallo en conexión, intente de nuevo.", life: 3000 });
        })



        // let _alumnos = db.filter(val => val.IdAlumno !== cancelacionids.IdAlumno);
        // setAlumnosPendientes(_alumnos);

        hideDisplayDialogConfirm_cancelacion();
        setCancelacion(false);
    }

    const Search = (e) => {
        e.preventDefault();
        if (alumnosPendientes !== null) {
            var text;
            text = filtro;

            const totalAlumnos = (alumnosPendientes.map(x => x.alumnos).flat(1));
            const arreglo = totalAlumnos.filter(function (o) {
                return ["Folio", "Nombre", "ApellidoPaterno", "ApellidoMaterno", "NombreCompleto"].some(function (k) {
                    if (o[k] !== null) {
                        return o[k].toString().indexOf(text) !== -1;
                    }
                });
            });
            // arreglo.sort((a, b) => {
            //     var textA = a.NombreCompleto
            //     var textB = b.NombreCompleto
            //     return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            // })
            // console.log(alumnosPendientes.some(r => arreglo.includes(r)))
            const arrResult = alumnosPendientes.filter(x => {
                if (x.alumnos.some(r => arreglo.includes(r))) {
                    return x
                } else {
                    return false
                }
            })
            setDb(arrResult)
        }
    }

    const [checkboxValue, setCheckboxValue] = useState([]);

    const onCheckboxChange = (e) => {
        let selectedValue = [...checkboxValue];
        if (e.checked) {
            selectedValue.push(e.value);
        } else {
            selectedValue.splice(selectedValue.indexOf(e.value), 1);
            seleccionarTodos === true && setSeleccionarTodos(false)
        }
        setCheckboxValue(selectedValue);
    };

    const onCheckboxTodosChange = (e) => {
        if (db !== null) {
            let selectedValue = [...checkboxValue];
            let selectedRows = db.slice(first, last)
            let all = selectedRows.map(x => x.IdEncEntrega)
            if (e.checked) {
                if (selectedValue.length === 0) {
                    setCheckboxValue(all)
                } else {
                    const res = all.filter(x => !selectedValue.includes(x))
                    res.forEach(alumno => {
                        selectedValue.push(alumno)
                    })
                    setCheckboxValue(selectedValue)
                }
            } else {
                setCheckboxValue([]);
            }
            setSeleccionarTodos(e.checked)
        }
    };

    return (
        <>
            <Menu link='pendientes' />
            <Toast ref={toast} />
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        {/* <Toolbar className="mb-4" left={leftToolbarTemplate}></Toolbar> */}
                        <form onSubmit={obtenerPendientes}>
                            <div className='grid' style={{ display: 'flex', paddingBottom: '0', background: '#f3f3f3', border: '1px solid #dee2e6' }} >
                                <div className='col-12 lg:col-9 md:col-8 sm:col-12' style={{ textAlign: 'center' }}  >
                                    <span className="p-input-icon-left w-full" >
                                        <i className='pi pi-search' />
                                        <InputText className='w-full' style={{ marginBottom: '5px' }} placeholder='Buscador por nombre y cupu' value={filtro} onChange={(e) => setFiltro(e.target.value.toUpperCase())} />
                                    </span>
                                </div>
                                <div className='mb-2 col-12 lg:col-3 md:col-4 sm:col-12 text-center lg:text-left md:text-left'>
                                    <Button label='Buscar' type='submit' className='p-button' style={{ width: '67px' }} />
                                    <Button label='Escanear' type='button' className='p-button ml-2' style={{ width: '67px', paddingLeft: '0', paddingRight: '0' }} onClick={() => setConfirmScanner(true)} />
                                    <Button label='Limpiar' type='button' className='p-button-outlined ml-2' style={{ width: '67px' }} onClick={() => { setFiltro(''); setAlumnosPendientes(null); setDb(null); obtenerTotalPendientes(); }} />
                                </div>
                            </div>
                        </form>
                        <div className='grid mt-3'>
                            <div className='col-6'>
                                <h5 style={{ color: '#9b2f3e', fontSize: '14px' }}>Mostrando <label style={{ fontWeight: '700' }}>{db !== null ? (db.length > 0 ? db.map(x => x.alumnos).flat().length : 0) : 0} <label style={{ fontWeight: '500' }}>de</label> {totalPendientes !== null && totalPendientes}</label> estudiantes pendientes</h5>
                            </div>
                            <div className='col-6 flex justify-content-end'>
                                <h6>Seleccionar todos (página)</h6>
                                <Checkbox className='ml-3' style={{ marginRight: '14px' }} checked={seleccionarTodos} onChange={onCheckboxTodosChange} />
                            </div>
                        </div>
                        {loading && <div><Loader /></div>}
                        {error && <MessageDetail color="error" mensaje={`Error ${error.status}: ${error.statusText}`} />}
                        <Tooltip target=".custom-target-icon" />

                        <DataView value={db} itemTemplate={dbItemTemplate} emptyMessage="No se encontraron resultados" paginator paginatorPosition='top' first={first} rows={rows} rowsPerPageOptions={[20, 50, 100, 200, 300]} onPage={e => { setRows(e.rows); setFirst(e.first); setLast(e.first + e.rows); }} />
                    </div>
                </div>
            </div>
            <div id='btnSiguiente' className='text-right m-3'>
                <Button label="Entregar" icon="pi pi-lock" className="p-button-rounded w-auto" onClick={() => handleRedirecTerminarMultiple()} />
            </div>

            <Dialog id='modalCancelacion' draggable={false} resizable={false} header="MOTIVO DE CANCELACIÓN" visible={cancelacion} style={{ width: '95%' }} modal onHide={() => setCancelacion(false)}>
                <div className="grid">
                    {loading_motivo && <div><Loader /></div>}
                    {motivo && motivo.map((el, index) =>
                        <div className="col-12 lg:col-4 surface-card " style={{ 'cursor': 'pointer' }} onClick={() => handleDisplayDialogConfirm_cancelarEntrega(el.IdMotivoCancelacion)} key={`m-${index}`}>
                            <div id='btn_motivoCancelar' className="p-2 border-round flex text-xl" style={{ border: 'solid 1px #9B2F3E', justifyContent: 'center', color: '#9B2F3E' }}>
                                {el.MotivoCancelacion}
                            </div>
                        </div>
                    )}
                </div>
            </Dialog>

            <Dialog visible={displayDialog_cancelacion} draggable={false} closable={false} resizable={false} style={{ width: '450px' }} header="CONFIRMACIÓN" modal footer={dialogFooter_cancelacion} onHide={hideDisplayDialogConfirm_cancelacion}>
                <div className="flex align-items-center justify-content-center">
                    <span>¿Está seguro de ejecutar esta cancelación?</span>
                </div>
            </Dialog>

            <Dialog id="modalEscanerQR" header="Escáner QR" resizable={false} draggable={false} visible={confirmScanner} onHide={() => { window.location.reload(); setConfirmScanner(false); }} style={{ width: '500px' }} modal className="p-fluid" >
                {confirmScanner && <ScannerFiltro carga={cagaPendientesQr} />}
            </Dialog>

            <Dialog visible={firma} style={{ width: '100%', height: '100%' }} header="Confirmación" modal onHide={() => setFirma(false)}>

            </Dialog>
        </>

    );
}

export default Pendientes;